<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="姓名">
          <el-input
            style="width: 180px"
            v-model.trim="queryForm.teacherName"
            clearable
            placeholder="请输入姓名"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input
            style="width: 180px"
            v-model.trim="queryForm.account"
            clearable
            placeholder="请输入登录账号"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select
            v-model="queryForm.teacherType"
            clearable
            placeholder="请选择"
            style="width: 140px"
          >
            <el-option label="负责人" value="1"></el-option>
            <el-option label="讲师" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryForm.status"
            clearable
            placeholder="请选择"
            style="width: 120px"
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column
          align="center"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column align="center" label="头像" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
              style="height:80px;"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="teacherName"
          label="姓名"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="teacherCode"
          label="编号"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="account"
          label="登录账号"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="类型" width="100">
          <template slot-scope="scope">
            {{ teacherTypeLabel(scope.row.teacherType) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="teacherTitle"
          label="头衔"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="mobile"
          label="手机号"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="String(scope.row.status) === '0' ? 'success' : 'info'"
            >
              {{ String(scope.row.status) === "0" ? "正常" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="info"
              @click="openForm('detail', scope.row)"
              >详情</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openForm('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <TeacherForm ref="teacherFormRef" @success="search" />
  </div>
</template>

<script>
import { getTeacherList, deleteTeacher } from "@/api/teacher";
import TeacherForm from "./TeacherForm.vue";

export default {
  name: "Teacher",
  components: { TeacherForm },
  data() {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        account: "",
        teacherType: undefined,
        status: undefined
      },
      listData: [],
      totals: 0,
      loading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    teacherTypeLabel(val) {
      const map = { "1": "负责人", "2": "讲师" };
      return map[String(val)] || "-";
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.search();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNum = 1;
      this.search();
    },
    resetSelect() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        account: "",
        teacherType: undefined,
        status: undefined
      };
      this.search();
    },
    async search() {
      this.loading = true;
      try {
        const params = { ...this.queryForm };
        Object.keys(params).forEach(key => {
          if (
            params[key] === "" ||
            params[key] === undefined ||
            params[key] === null
          ) {
            delete params[key];
          }
        });
        const result = await getTeacherList(params);
        const data = (result && result.data) || {};
        this.listData = data.rows || [];
        this.totals = Number(data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    openForm(type, row) {
      this.$refs.teacherFormRef.open(type, row);
    },
    deleteInfo(row) {
      this.$confirm("确定要删除该教师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteTeacher(row.teacherId);
            this.$message.success("删除成功");
            this.search();
          } catch (e) {}
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Teacher/index.vue